import RichText from '@eneco/components/RichText/RichText';
import { Image } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';

export const AnticipationAnnouncementCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const image = fields.anticipationAnnouncementCard.image?.value?.formats[0];

  return (
    <StyledDashboardBlock>
      <RichText html={fields.anticipationAnnouncementCard?.description?.value} />
      {image && <Image src={image.src} alt={fields.anticipationAnnouncementCard?.image?.value?.alt} />}
    </StyledDashboardBlock>
  );
};
